import React from 'react'
import { Trans } from '@lingui/macro'
import { DataTableDashboard } from '../DashboardContentTable/DataTableDashboard';
import { TableBody, TableHeader } from './tableData';
import { PopupPanelDashboard } from '../DashboardContentTable/PopupPanelDashboard';

import { DashboardContentPage } from '../DashboardContentTable';

import { typePaginationDashboardObject } from '../DashboardContentTable/PaginationDashboard/PaginationDashboard';

import { FiltersDashboard } from '../DashboardContentTable/FiltersDashboard';
import { InputSearch } from '../../../UI/InputSearch/InputSearch';
import { DTransferCashDesksManagementFilters } from 'components/containers/dashboard/dataTransferCashDesks/filters';

import { IdTransferCashDesksStateDataItem } from 'model/dashboardTransferCashDesks/dTransferCashDesksReducer';

import { PopupAdd } from 'components/containers/dashboard/dataTransferCashDesks/popupContents/popupAdd';
import { PopupDetails } from 'components/containers/dashboard/dataTransferCashDesks/popupContents/popupDetails';
import { DTransferCashDesksManagementActions } from 'components/containers/dashboard/dataTransferCashDesks/actions';


// Type
export type typeViewDataTransferCashDesks = {
    variant?: string
    setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>

    openFilterBar: boolean
    setOpenFilterBar: React.Dispatch<React.SetStateAction<boolean>>

    openPopupDetails: boolean
    setOpenPopupDetails: React.Dispatch<React.SetStateAction<boolean>>

    openPopupAdd: boolean
    setOpenPopupAdd: React.Dispatch<React.SetStateAction<boolean>>


    searchValue: string
    onChangeSearchValue: (e: ( React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement> )) => void
    onEnterSearch: () => void
    onClearSearch: () => void

    //  rowsActions: typeDataTransferCashDesksRowActions

    currentItem: IdTransferCashDesksStateDataItem | undefined

    pagination?: typePaginationDashboardObject
    isActiveFilters: boolean
    setIsActiveFilters: React.Dispatch<React.SetStateAction<boolean>>

}
// Component
export const ViewDataTransferCashDesks: React.FC<typeViewDataTransferCashDesks> = (
    {
        variant,
        setSidebarOpen,
        openFilterBar, setOpenFilterBar,

        openPopupDetails, setOpenPopupDetails,
        openPopupAdd, setOpenPopupAdd,


        searchValue, onChangeSearchValue,
        onClearSearch, onEnterSearch,

        //  rowsActions,
        currentItem,
        isActiveFilters, setIsActiveFilters
    }
) => {
    return (
        <DashboardContentPage
            headerTitle={ <Trans>Cash desk's transfers</Trans> }
            setSidebarOpen={ setSidebarOpen }
            actions={ <DTransferCashDesksManagementActions onClickAdd={ () => setOpenPopupAdd(true) }/> }
        >
            {/* Filter bar */ }
            <FiltersDashboard
                variant={ variant }
                filters={ {
                    filtersForm: <DTransferCashDesksManagementFilters setOpenFilterBar={ setOpenFilterBar }  setIsActiveFilters={setIsActiveFilters}/>,
                    openFilterBar: openFilterBar,
                    setOpenFilterBar: setOpenFilterBar,
                } }
                searchBar={ <InputSearch
                    id="posSnSearch"
                    name="posSnSearch"
                    placeholder="Search by cash desk's serial number"
                    value={ searchValue }
                    onChange={ onChangeSearchValue }
                    onClear={ onClearSearch }
                    onKeyEnterDown={ onEnterSearch }
                /> }
                isActiveFilters={isActiveFilters}
            />

            {/* Table data */ }
            <DataTableDashboard
                tableHeader={ <TableHeader/> }
                tableBody={ <TableBody variant={ variant } setOpenPopupDetails={ setOpenPopupDetails }/> }

            />

            {/* Popup Add item dialog */ }
            <PopupPanelDashboard
                title={ <Trans>Add cash desk transfer</Trans> }
                openPopup={ openPopupAdd }
                setOpenPopup={ setOpenPopupAdd }
            >
                <PopupAdd setOpenPopup={ setOpenPopupAdd }/>
            </PopupPanelDashboard>


            {/* Popup Details */ }
            <PopupPanelDashboard
                title={ <Trans>Details</Trans> }
                openPopup={ openPopupDetails }
                setOpenPopup={ setOpenPopupDetails }

            >
                <PopupDetails setOpenPopup={ setOpenPopupDetails }/>
            </PopupPanelDashboard>

        </DashboardContentPage>
    )
}
